import { tv, type VariantProps } from 'tailwind-variants'

import { cn } from '@/utils'

const swatchVariants = tv({
  base: 'inline-block shrink-0',
  variants: {
    size: {
      sm: 'size-2',
      md: 'size-2.5',
      lg: 'size-3',
    },
    shape: {
      dot: 'rounded-full',
      square: 'rounded-sm',
    },
  },
  compoundVariants: [
    { size: 'sm', shape: 'square', class: 'rounded-xs' },
    { size: 'md', shape: 'square', class: 'rounded-[3px]' },
  ],
  defaultVariants: {
    size: 'sm',
    shape: 'dot',
  },
})

export interface SwatchProps extends VariantProps<typeof swatchVariants> {
  // Runtime palette colors (d3 scales, semanticColors) arrive as a value rather than a class, so the
  // swatch still paints when a chart is rasterized to PNG. Closed vocabularies pass a bg-* className.
  color?: string
  className?: string
}

// The colored square or dot that explains the label sitting next to it: chart legends, status
// readouts, account-mix rows. Owns size and shape only; the caller owns what the color means.
export const Swatch = ({ size, shape, color, className }: SwatchProps) => (
  <span
    className={cn(swatchVariants({ size, shape }), className)}
    style={color ? { backgroundColor: color } : undefined}
  />
)
